import {
  BlockStyles,
  InputBar,
  InputBars,
} from "src/components/SearchInput/SearchInput";
import { Skeleton } from "src/components/Skeleton/Skeleton";
import styled from "styled-components";

export function TripSearchBarSkeleton() {
  return (
    <InputBars>
      <InputBar>
        <SkeletonVariant height={48} width={200} />
        <SkeletonVariant height={48} width={200} />
        <SkeletonVariant height={48} width={200} />
      </InputBar>
    </InputBars>
  );
}

const SkeletonVariant = styled(Skeleton)`
  ${BlockStyles}
  max-width: 200px;
  max-height: 48px;
`;
